export const validation = {
  customCode: { required: true },
  headingMaxChar: 120,
  paragraphMaxChar: 1500
}
